<div class="support-case-widget-container">
  <div class="container header p-3">
    <div class="row">
      <div class="col-6 chart-title text-truncate pr-0">Case Status</div>
      <div class="col-6 d-flex justify-content-end">
        <button
          (click)="rerouteOnClick()"
          class="rts-inverse-button show-all-btn"
          *appFeature="'AllSites'">
          Show All
        </button>
      </div>
    </div>
  </div>
  <div class="chart-container-wrapper">
    <ng-container *ngIf="isCaseStatusLoading$ | async; else content">
      <div class="chart-container justify-content-center">
        <div>
          <mat-spinner
            class="loading-spinner"
            strokeWidth="6"
            diameter="75"></mat-spinner>
        </div>
      </div>
    </ng-container>
    <ng-template #content>
      <div class="chart-container">
        <figure id="donut-chart"></figure>
        <div class="chart-key-container" *ngIf="svg !== undefined">
          <div
            class="col-12 chart-key-row"
            *ngFor="let caseType of caseTypeCodeToColorMap | keyvalue">
            <div
              class="chart-key"
              [ngStyle]="{ 'background-color': caseType.value.color }"></div>
            <div class="chart-key-text">
              {{ caseType.key }} ({{ caseType.value.count }})
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
